<template>
    <div class="hash">
        <el-descriptions v-if="transactionId" title="" :column="1" border style="width: 1200px;margin: 0 auto;margin-top: 50px;" >
            <el-descriptions-item label="交易哈希">
                {{transactionId}}
            </el-descriptions-item>
            <el-descriptions-item label="状态">
                <span v-if="status==0">待上链</span>
                <span v-if="status==1">上链成功</span>
                <span v-if="status==2">上链失败</span>
            </el-descriptions-item>
            <el-descriptions-item label="商品编号">{{tokenId}}</el-descriptions-item>
            <el-descriptions-item label="存证名称">{{owner.replace(/中钞/g, "融权")}}</el-descriptions-item>
            <el-descriptions-item label="时间">{{createdt | dateFormate}}</el-descriptions-item>
            <el-descriptions-item label="存证">
                <img :src="tokenURL" alt="" height="300">
            </el-descriptions-item>
        </el-descriptions>
        <div v-if="!transactionId" style="margin: 0 auto;height: 100px;line-height: 100px;color: #606266;font-size: 14px;">暂无数据</div>
    </div>
</template>

<script>
    export default {
        name: "search-details",
        data(){
            return{
                transactionId:'',
                chaincodename:'',
                createdt:'',
                tokenId:'',
                owner:'',
                tokenURL:'',
                status:'',
            }
        },
        created() {
            this.getHashs()
        },
        methods:{
            getHashs(){
                this.$http.get(this.$http.baseURL2+'/nfe/sync/tradinglist',{
                    params:{
                        chaixTxId:this.$route.query.id,
                    },
                }).then((res)=>{
                    this.transactionId = res.data.data.chain_tx_id
                    this.chaincodename = res.data.data.chaincodename
                    this.createdt = res.data.data.created_time
                    this.tokenId = res.data.data.token_id
                    this.owner = res.data.data.token_name
                    this.tokenURL = res.data.data.token_uri
                    this.status = res.data.data.status
                })
            }
        }
    }
</script>

<style scoped lang="scss">
.hsah{

}
</style>